export default "__VITE_ASSET__BUGfljg3__"